import React from 'react';
import { ProviderCard } from './ProviderCard';

export function CuratedSection({ title, subtitle, icon: Icon, providers, testId, favouritedIds, onToggleFavourite, isLoggedIn, headerAction }) {
  if (!providers || providers.length === 0) return null;
  return (
    <div className="mb-10" data-testid={testId}>
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-[#F9F6F0] flex items-center justify-center">
          <Icon className="h-5 w-5 text-[#D4AF37]" />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="font-heading text-xl font-medium text-[#1A1A1A]">{title}</h2>
          <p className="text-xs text-stone-400">{subtitle}</p>
        </div>
        {headerAction && (
          <div className="flex-shrink-0">{headerAction}</div>
        )}
      </div>
      <div className="columns-2 sm:columns-3 lg:columns-4 xl:columns-5 2xl:columns-6 gap-2 lg:gap-3">
        {providers.map(p => (
          <div key={p.provider_id} className="break-inside-avoid mb-2 lg:mb-3">
            <ProviderCard
              provider={p}
              isFavourited={favouritedIds.has(p.provider_id)}
              onToggleFavourite={onToggleFavourite}
              isLoggedIn={isLoggedIn}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
